/**
 * @file index.tsx
 *
 * @fileoverview Renders matching jobs for expired job detail pages.
 */

import JobRecommenderLayout from '~/jobiqo/components/JobRecommender/components/Layout';
import { useQuery } from '@apollo/client';
import getMatchingJobs from '~/jobiqo/components/JobRecommender/graphql/queries/getMatchingJobs';
import { FormattedMessage } from 'react-intl';

interface JobRecommenderSimilarJobsProps {
  /**
   * The job id.
   */
  jobId: number;
}

export default function JobRecommenderSimilarJobs({
  jobId,
}: JobRecommenderSimilarJobsProps) {
  const { data, error, loading } = useQuery(getMatchingJobs(), {
    variables: {
      context: 'JOB_DETAIL_EXPIRED',
      entityId: jobId,
    },
  });
  const matchingResult = data?.getMatchingJobs;

  return (
    <JobRecommenderLayout
      loading={loading}
      error={
        !!error || (matchingResult?.errors && matchingResult.errors.length > 0)
      }
      jobs={matchingResult?.items?.map((item: any) => item.job)}
      Description={
        <FormattedMessage
          id="job_recommender_similar_jobs_description"
          defaultMessage="This job has expired, you could browse through similar jobs - maybe the next big step is already waiting for you."
        />
      }
    />
  );
}

export { JobRecommenderSimilarJobs };
